import GeneralTranslations from "../../../Common/ModuleTranslations/en";
import CONSTANTS from "../../constants";

function formTypeHelperText({ formValues }) {
  switch (formValues.type) {
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.RESERVATION_CONFIRMATION:
      return "Sent when the user makes a reservation. There can only be one template active at a time.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.RESERVATION_STATUS_RED:
      return "Send when the reservation payment fails.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.POST_STAY:
      return "Will be sent days after the guest arrived.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.PRE_STAY:
      return "Will be sent days before the guest's stay.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.CART_ABANDONMENT:
      return "<div><strong style='color:red;'>To activate cart abandonment, you MUST contact Support.</strong><br/>The email will be sent if the guest had at least one reservation in their cart.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.GIFT_CARD:
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.PURCHASE_EVENT:
      return "";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.UPSELL_AVAILABLE:
      return "<div><strong style='color:red;'>To activate the \"Upgrade\" feature, you MUST contact Support.</strong><br/>The email will be sent if the guest has made a booking that matches the Upgrade rule settings.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.QUOTATION_PRICE:
      return "<div><strong style='color:red;'>To activate the \"Quote Tool\", you MUST contact Support.</strong><br/>The email will be sent when a quotation is created and sent.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.WAITING_LIST_AVAILABLE:
      return "The email will be sent when the hotel has availability.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.LOYALTY_WELCOME:
      return "<div><strong style='color:red;'>To activate the \"Loyalty Welcome\" email, you must have the loyalty feature enabled in the engine.</strong><br/>The email will be sent when a non-loyalty user registers.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.LOYALTY_WELCOME_VALIDATED:
      return "<div><strong style='color:red;'>To activate the \"Agencies\" email, you must have the loyalty feature enabled in the engine.</strong><br/>The email will be sent when a new agency registers.</div>";
    default:
      return "";
  }
}

export default {
  locale: "en",
  name: "Email Templates",
  translation: {
    displayName: "Translations",
  },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "active",
        displayName: "Active",
      },
      {
        fieldName: "type",
        displayName: "Email type",
      },
      {
        fieldName: "emailDestinationType",
        displayName: "Email Destinations",
      },
      {
        fieldName: "preferred",
        displayName: "Default",
      },
      {
        fieldName: "motors",
        displayName: "Motors",
      },
      {
        fieldName: "uso",
        displayName: "Usage",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "Ticker de hotel",
      },
      {
        fieldName: "isActive",
        displayName: "Active",
      },
      {
        fieldName: "preferred",
        description: "Mark as default",
      },
      {
        fieldName: "preferredInactiveHint",
        value: "Only active templates can be set as default.",
      },
      {
        fieldName: "type",
        displayName: "Email Type",
        optionDisplay: {
          RESERVATION_CONFIRMATION: {
            label: "Reservation Confirmation",
          },
          RESERVATION_STATUS_RED: {
            label: "Failed Payment",
          },
          GIFT_CARD: {
            label: "Gift Card (with a stay)",
          },
          PURCHASE_EVENT: {
            label: "Gift Card (without a stay)",
          },
          POST_STAY: {
            label: "Post-stay",
          },
          PRE_STAY: {
            label: "Pre-stay",
          },
          CART_ABANDONMENT: {
            label: "Cart abandonment",
          },
          WAITING_LIST_AVAILABLE: {
            label: "Waiting List",
          },
          UPSELL_AVAILABLE: {
            label: "Upgrade",
          },
        },
        transform: ({ field, userInfo, formValues }) => {
          const isWitAdmin = userInfo?.isWitAdmin;
          const extraOptions = isWitAdmin
            ? {
                RESERVATION_STATUS_ORANGE: {
                  label: "Abandoned Payment Process",
                },
              }
            : {};
          return {
            ...field,
            optionDisplay: { ...field.optionDisplay, ...extraOptions },
            className: "negativeMargin",
            helpText: formTypeHelperText({ formValues }),
          };
        },
      },
      {
        fieldName: "templateType",
        displayName: "Template type",
        optionDisplay: {
          DEFAULT: {
            label: "Default template",
          },
          CUSTOM: {
            label: "Custom template",
          },
        },
      },
      {
        fieldName: "singleMailOnMultipleRoomStays",
        description:
          "For multiple reservations group confirmations in a single email (Only visible for WIT)",
      },
      {
        fieldName: "delay",
        displayName: "Delay",
        optionDisplay: {
          5: {
            label: "5 minutes",
          },
          10: {
            label: "10 minutes",
          },
          15: {
            label: "15 minutes",
          },
          30: {
            label: "30 minutes",
          },
          45: {
            label: "45 minutes",
          },
          60: {
            label: "60 minutes",
          },
        },
        helpText: "Amount of minutes before an email is sent.",
      },
      {
        fieldName: "delayCartAbandonment",
        displayName: "Delay",
        optionDisplay: {
          60: {
            label: "1 hour",
          },
          120: {
            label: "2 hours",
          },
          180: {
            label: "3 hours",
          },
          360: {
            label: "6 hours",
          },
          720: {
            label: "12 hours",
          },
          1440: {
            label: "24 hours",
          },
          2880: {
            label: "48 hours",
          },
        },
        helpText: "Time after an abandoned cart that the email will be submitted.",
      },
      {
        fieldName: "delayCheckout",
        displayName: "Number of days after check-out to submit",
      },
      {
        fieldName: "delayCheckin",
        displayName: "Number of days before check-in to submit",
      },
      {
        fieldName: "chronoUnit",
        displayName: "Delay units",
        optionDisplay: {
          MINUTES: {
            label: "Minutes",
          },
          HOURS: {
            label: "Hours",
          },
          DAYS: {
            label: "Days",
          },
        },
      },
      {
        fieldName: "emailDestinationType",
        displayName: "Email Destinations",
        optionDisplay: {
          ALL: {
            label: "All",
          },
          GUEST: {
            label: "Guest",
          },
          PROPERTY: {
            label: "Property",
          },
        },
      },
      {
        fieldName: "emailGuestType",
        displayName: "Email guest type",
        optionDisplay: {
          ALL: {
            label: "All",
          },
          LOYALTY_GUEST: {
            label: "Loyalty guest",
          },
          NON_LOYALTY_GUEST: {
            label: "Non loyalty guest",
          },
        },
      },
      {
        fieldName: "subject",
        displayName: "Subject",
      },
      {
        fieldName: "body",
        displayName: "Body",
      },
      {
        fieldName: "header",
        displayName: "Header",
      },
      {
        fieldName: "footer",
        displayName: "Footer",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Property selection",
      },
    ],
  },
};
